import { render, staticRenderFns } from "./AddPeer.vue?vue&type=template&id=1dc5c562&"
import script from "./AddPeer.vue?vue&type=script&lang=js&"
export * from "./AddPeer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports